import { isLocal } from "@cores/enviromentExtension";

export class Creator {
    static instance = null;

    static getInstance() {
        if (!this.instance) {
            this.instance = new SiteMode();
        }
        return this.instance;
    }
}

class SiteMode {
    get() {
        return location.pathname.includes("/library/") ? "CMS" : "CONSOLE";
    }
}

export const siteMode = Creator.getInstance();
